import angular from 'angular';
import routers from './routers.js';
import enterpriseReportQueryCtrl from './enterpriseReportQueryCtrl.js';
import tableQueryConfigERQ from './tableQueryConfig';

export default angular
  .module('declaration.corporateIncomeTax.enterpriseReportQuery', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config);
      });
    },
  ])
  .controller('enterpriseReportQueryCtrl', enterpriseReportQueryCtrl)
  .value('tableQueryConfigERQ', tableQueryConfigERQ).name;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/enterpriseReportQuery/index.js